import React, { useEffect, useState } from "react";
import { useTreeContext } from "../../context/TreeDataContext";
import { usePublicScreenContext } from "../../context/PublicScreenContext";
import { useNavigate, useParams } from "react-router-dom";
import { getDefaultConfig } from "../../utils/Config/getDefaultConfig";
// import ZinoLogo from "../../images/zino-logo-orange.svg";
import defaultImage from "../../images/defaultImage.png";

import RightSideBar from "../../components/SideBar/RightSideBar";
import fileFolderConfig from "../../commonFunctions/fileFolderConfig";
import PageInfoAndActionBar from "../../Layouts/PageInfoAndActionBar";
import DropLayout from "../../components/ReactGridLayout/DropArea/DropLayout";
import EditScreenField from "../Screen/EditScreenField";
import MaterialIcon from "../../components/BuilderComponents/MaterialIcon";
import { generateObjectId } from "../../utils/objectIdUtils";
import { toastError } from "../../utils/toastUtils";
import { getFolderFileById } from "../../utils/treeData/folderEditorUtils";

const PublicScreenRenderer = () => {
  const [dragFromOutside, setDragFromOutside] = useState(false);
  const { publicAccessExplorerData } = useTreeContext();
  const [newBlockData, setNewBlockData] = useState([]);
  // const [staticFields, setStaticFields] = useState([]);
  const [allFormobj, setAllFormobj] = useState({});

  const {
    currentPublicScreenData,
    selectedPublicScreen,
    layoutData,
    layouts,
    nestedGridData,
    setLayouts,
    savePublicScreenJson,
    allPublicForms
  } = usePublicScreenContext();
  const { publicId, appId } = useParams();
  const navigate = useNavigate();

  const [editElementRightsidebar, setEditElementRightsidebar] = useState({
    id: "",
    type: "",
    show: false,
    config: {}
  });

  const calculateElementDimensions = (elementType, item) => {
    switch (elementType) {
      case "recordsview":
      case "publicform":
        return { ...item, h: 5, w: 12 };
      case "mapsview":
        return { ...item, h: 3, w: 12 };
      case "detailsview":
        return { ...item, h: 5, w: 12 };
      case "chart":
        return { ...item, h: 7, w: 12 };
      case "button":
      case "dropdown":
        return { ...item, h: 1, w: 3 };
      default:
        return { ...item, h: 1, w: 12 };
    }
  };

  const getElementConfig = (element) => {
    const { type, id } = element;
    // const { type } = element;
    switch (type) {
      case "button":
        return getDefaultConfig("button");
      case "dropdown":
        return getDefaultConfig("dropdown");
      case "smview":
        return { config: { sm_id: "" } };
      case "html":
        return { content: "" };
      case "spacer":
        return { height: 50 };
      case "image":
        return { source: defaultImage, className: {} };
      case "label":
        return { name: "label", className: {}, inline_style: {}, icon: "" };
      case "tabview":
        const newId = generateObjectId();
        const newId2 = generateObjectId();

        const newObj = {
          display: "Tab 1",
          id: newId,
          icon: ""
        };
        const newObj2 = {
          display: "Tab 2",
          id: newId2,
          icon: ""
        };

        nestedGridData.current[newId] = [];
        nestedGridData.current[newId2] = [];

        return {
          display: "Tabview",
          config: {
            headerData: [newObj, newObj2],
            bodyData: {
              [newId]: [],
              [newId2]: []
            }
          },
          vertical: false,
          className: {},
          inline_style: {},
          icon: ""
        };

      case "publicform":
        const obj = layouts.find((item) => item.i === id);
        if (obj) {
          toastError("Form Already Exists");
          return null;
        }
        const formData = getFormData(id);
        return formData;
      // return [];
      default:
        return null;
    }
  };
  const getFormData = (id) => {
    let finalBlock = allFormobj[id];

    // if (!finalBlock.hasOwnProperty("config")) {
    //   //right now every block has config but old block has no config so letter will remove this condition
    //   finalBlock.config = finalBlock.data;
    //   delete finalBlock["data"];
    // }
    return finalBlock;
  };
  const onDrop = (elemParams, item, e) => {
    if (!item || !item.i) {
      return null;
    }
    let element = e.dataTransfer.getData("type");
    if (!element || element === "null") return null;
    setDragFromOutside(false);
    let elementObject = JSON.parse(element);
    const { type } = elementObject;
    let elementConfig = getElementConfig(elementObject);
    if (!elementConfig) return null;
    if (type === "publicform") {
      item.resizeHandles = ["se"];
      elementObject = { ...elementObject, ...elementConfig };
    } else {
      elementObject = { ...elementObject, ...elementConfig, id: item.i };
    }
    elementConfig = {
      ...elementObject,
      className: {},
      inline_style: {},
      icon: "",
      colorif: []
    };

    item.i = elementObject.id;
    layoutData.current[item.i] = elementObject;
    const newItem = calculateElementDimensions(elementObject.type, item);
    return newItem;
    // setLayouts(updatedLayouts);
    // if (itemId) {
    //   const newNestedGridData = JSON.parse(JSON.stringify(nestedGridData.current));
    //   if (layoutData.current[itemId].type === "tabview") {
    //     newNestedGridData[selectedTabID] = [...newNestedGridData[selectedTabID], item];
    //     nestedGridData.current = newNestedGridData;
    //     item.h = 3;
    //   } else {
    //     newNestedGridData[itemId] = [...newNestedGridData[itemId], item];
    //     nestedGridData.current = newNestedGridData;
    //   }
    // }
    // if (itemId) {
    //   setLayouts([...layouts]);
    // } else {
    //   setLayouts([newItem, ...layouts]);
    // }
  };
  const openEditModal = (id) => {
    const data = [];
    const { type } = layoutData.current[id];
    if (
      type === "smview" ||
      type === "html" ||
      type === "image" ||
      type === "label" ||
      type === "spacer" ||
      type === "tabview"
    ) {
      const obj = {
        id: id,
        type: layoutData.current[id].type,
        show: true,
        device: currentPublicScreenData.device,
        config: layoutData.current[id]
      };
      setEditElementRightsidebar(obj);
      return;
    }
    layouts.forEach((element) => {
      if (layoutData.current[element.i].type !== "button" && layoutData.current[element.i].type !== "dropdown") {
        data.push(layoutData.current[element.i]);
      }
    });
    const obj = {
      id: id,
      type: layoutData.current[id].type,
      show: true,
      device: currentPublicScreenData.device,
      config: layoutData.current[id],
      elements: data
    };
    setEditElementRightsidebar(obj);
  };
  const editScreenElement = (id) => {
    const type = layoutData.current[id].type;
    const inlineElements = ["button", "dropdown", "smview", "html", "image", "label", "spacer", "tabview"];
    const isInlineEdit = inlineElements.includes(type);
    if (isInlineEdit) {
      openEditModal(id);
    } else {
      navigate(`../../${appId}/applicationblock/${id}`);
    }
  };

  const saveEditElement = (config) => {
    // layoutData.current[config.id] = config;
    const newLayoutData = JSON.parse(JSON.stringify(layoutData.current));
    newLayoutData[config.id] = config;
    layoutData.current = newLayoutData;
    if (config.type === "html") {
      setEditElementRightsidebar({ show: false, id: "", config: {}, type: "" });
    } else {
      setLayouts([...layouts]);
    }
  };

  const closeEditRightsidebar = () => {
    setEditElementRightsidebar({
      id: "",
      type: "",
      show: false,
      config: {}
    });
  };
  const handleDragStart = (e, name, id, parentData) => {
    setDragFromOutside(true);
    if (e.nativeEvent instanceof DragEvent) {
      e.dataTransfer.setData(
        "type",
        JSON.stringify({ id: id, name: name, type: parentData.split("/")[parentData.split("/").length - 1] })
      );
    }
  };

  const generateComponentsTree = () => {
    try {
      const buttonField = fileFolderConfig.getFileConfig("button", "Button", "button", false, false);
      // const dropdownField = fileFolderConfig.getFileConfig("dropdown", "Dropdown", "dropdown", false, false);
      const htmlContent = fileFolderConfig.getFileConfig("html", "HTML", "html", false, false);
      const imageContent = fileFolderConfig.getFileConfig("image", "Image", "image", false, false);
      const labelContent = fileFolderConfig.getFileConfig("label", "Label", "label", false, false);
      const spacerContent = fileFolderConfig.getFileConfig("spacer", "Spacer", "spacer", false, false);
      // const tabContent = fileFolderConfig.getFileConfig("tabview", "Tabview", "tabview", false, false);
      const buttonFolder = [buttonField, htmlContent, imageContent, labelContent, spacerContent];

      //   setStaticFields(buttonFolder);
      // setNewBlockData([buttonFolder]);
      setNewBlockData([buttonFolder, [publicAccessExplorerData[2]]]);

      const finalObject = {};
      allPublicForms.forEach((item) => {
        finalObject[item.id] = item;
      });
      setAllFormobj(finalObject);
    } catch (error) {
      console.log(error);
    }
  };
  useEffect(() => {
    if (!publicAccessExplorerData) return;

    const file = getFolderFileById(publicAccessExplorerData, publicId);
    generateComponentsTree(file.parentData);

    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [publicId, publicAccessExplorerData]);

  return (
    <>
      <div className="screen_outer_body">
        <div className={currentPublicScreenData.device === "mobile" ? "mobile_screen_pages" : "desktop_screen_pages"}>
          <PageInfoAndActionBar
            pagePath={`Public Screens/${selectedPublicScreen.name}`}
            // clonePage={handleCloneScreen}
            savePage={savePublicScreenJson}
            // saveOwner={() => setIsOwnerAssignment(true)}
            // customFunc={() => setCustomOpen(true)}
            currentConfig={[layouts, layoutData.current]}
            pageName="publicaccess"
          />

          <div
            className="screens_page_outer page_main_section"
            style={{ width: "calc(102vw - 486px)", flexDirection: "column" }}
          >
            <div
              className="screen_header_draggable_outer h_100"
              style={{
                width: selectedPublicScreen.parentData === "mobile" ? "50%" : "100%",
                margin: "0px auto"
              }}
            >
              <DropLayout
                layout={layouts}
                setLayout={setLayouts}
                layoutData={layoutData}
                nestedGridData={nestedGridData}
                dragFromOutside={dragFromOutside}
                setDragFromOutside={setDragFromOutside}
                onDrop={onDrop}
                editElement={editScreenElement}
              />
            </div>
          </div>
        </div>
        <RightSideBar
          explorerData={newBlockData}
          setExplorerData={setNewBlockData}
          handleDragStart={handleDragStart}
          actionNeeded={false}
          type="All Blocks"
        />

        {editElementRightsidebar.show && (
          <div className="sidebarView_edit_outer edit_open">
            <div className="sidebar_top_header">
              <span>{editElementRightsidebar.type}</span>
              <MaterialIcon name="close" className="section_close_darkIcon" onClick={closeEditRightsidebar} />
            </div>
            <EditScreenField
              editElementRightsidebar={editElementRightsidebar}
              saveElement={saveEditElement}
              device={selectedPublicScreen.parentData}
            />
          </div>
        )}
      </div>
    </>
  );
};

export default PublicScreenRenderer;
